import { UseFormReturn } from 'react-hook-form/dist/types'
import { graphql } from 'relay-runtime'

import FormSelectAsync from '../../components/FormSelectAsync'
import { fetchGraphQL } from '../../relay'
import { AdSetAsyncMultiSelectQuery$data } from './__generated__/AdSetAsyncMultiSelectQuery.graphql'
import { useGlobalState } from '../../state/v2/store'

interface AdSetAsyncMultiSelectProps {
  useForm: UseFormReturn<any>
  required?: boolean
}

interface response<T> {
  data: T
}

const searchAdSetsQuery = graphql`
  query AdSetAsyncMultiSelectQuery($input: ListMetaAdSetRequest!) {
    listMetaAdSets(input: $input) {
      data {
        id
        name
        campaignName
        metaAdAccount {
          id
          name
        }
        effectiveStatus
        status
      }
    }
  }
`

export const adSetToSelectOption = (
  adSet: AdSetAsyncMultiSelectQuery$data['listMetaAdSets']['data'][0]
) => ({
  label: `${adSet.name} - ${adSet.campaignName} - ${
    adSet.metaAdAccount?.name ?? '⚠️ no name'
  }`,
  value: adSet.id,
})

const AdSetAsyncMultiSelect = ({
  useForm,
  required,
}: AdSetAsyncMultiSelectProps) => {
  const brandId = useGlobalState((b) => b.brand?.map((brand) => brand.id).join(","))

  // TEMP FIX for fetching more than 20 ad sets, need to implement pagination
  const fetchRequest = async (search: String) => {
    const rawQuery = (searchAdSetsQuery as any).default.params.text
    const resp: response<AdSetAsyncMultiSelectQuery$data> = await fetchGraphQL(
      rawQuery,
      {
        input: { brandId, search, pageNumber: 0, pageSize: 20 },
      }
    )
    const resp2: response<AdSetAsyncMultiSelectQuery$data> =
      resp.data.listMetaAdSets.data.length === 20
        ? await fetchGraphQL(rawQuery, {
            input: { brandId, search, pageNumber: 1, pageSize: 20 },
          })
        : { data: { listMetaAdSets: { data: [] } } }

    return [
      ...resp.data.listMetaAdSets.data.map(adSetToSelectOption),
      ...resp2.data.listMetaAdSets.data.map(adSetToSelectOption),
    ]
  }

  return (
    <>
      <FormSelectAsync
        useForm={useForm}
        label="Ad Sets"
        name="adSets"
        required={required}
        fetchRequest={fetchRequest}
        isMulti
      />
    </>
  )
}

export default AdSetAsyncMultiSelect
